import { useMutation, useQueryClient } from '@tanstack/react-query';

const THREADS_QUERY_KEY = ['AI', 'THREADS'];

/**
 * Hook to invalidate and refetch threads so sidebar shows updated list/titles.
 * @returns Mutation function to refresh threads
 */
export const useRefreshThreads = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      await queryClient.invalidateQueries({ queryKey: THREADS_QUERY_KEY });
    },
  });
};
